module.exports = __webpack_public_path__ + "img/Logo_Duoc.535e1c5b.png";